module.exports = __webpack_public_path__ + "static/media/Icons-Toggle_off.4d5db7ac.svg";